<template>
  <div class="map-search">
    <van-search
      v-model="search"
      shape="round"
      :background="'transparent'"
      placeholder="请输入搜索关键词"
      @blur="listVisible = false"
      @search="handleSearch"
    />
    <div v-show="listVisible" class="mask" @click="listVisible = false" />
    <van-list
      v-show="listVisible"
      v-model="loading"
      :finished="true"
      finished-text="没有更多了"
    >
      <div v-for="i in result" :key="i.id" class="suggestion-item" @click="handleSelectPosition(i)">
        <div style="font-size: 14px;line-height: 1;">
          {{ i.name }}
        </div>
        <div style="font-size: 12px;line-height: 2;color: #aaa;">
          {{ i.district }}
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getAMap } from '@/utils/tool'

let autoComplete
export default {
  name: 'SearchInput',
  data() {
    return {
      search: '',
      loading: false,
      listVisible: false,
      result: []
    }
  },
  created() {
    getAMap(['AMap.AutoComplete']).then(AMap => {
      autoComplete = new AMap.AutoComplete({
        city: '四川省'
      })
    })
  },
  methods: {
    handleSearch(queryString, cb) {
      if (!queryString) return
      this.loading = true
      this.listVisible = true
      autoComplete.search(queryString, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.result = result.tips.filter(i => i.location)
        } else {
          this.$toast('地点搜索失败')
        }
        this.loading = false
      })
    },
    handleSelectPosition(val) {
      this.listVisible = false
      this.search = val.name
      this.$emit('select', {
        center: val.location.toArray(),
        zoom: 18
      })
    }
  }
}
</script>

<style lang="less" scoped>
.map-search {
  position: relative;
}
.van-search {
  position: relative;
  z-index: 1;
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  width: 100vw;
  height: 100vh;
}
.van-list {
  position: relative;
  margin: 0 10px;
  background: #fff;
  border-radius: 4px;
  max-height: 50vh;
  overflow-y: auto;
  z-index: 1;
}
.suggestion-item {
  padding: 4px 10px;
  &:active {
    background-color: #f2f3f5;
  }
}
</style>
